import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { NavLink } from "react-router-dom";

const ReturnExchange = () => {
  return (
    <Container className="my-5" data-no-translate>
      <Row className="justify-content-center">
        <Col lg={10}>
          <Card className="shadow-sm border-0">
            <Card.Body className="p-4 p-md-5">
              <h1 className="fw-bold mb-4">
                রিটার্ন, রিফান্ড ও এক্সচেঞ্জ পলিসি – {process.env.REACT_APP_NAME} 🧾
              </h1>

              <p>
                আসসালামু আলাইকুম,
                <br />
                সম্মানিত গ্রাহক, <strong>{process.env.REACT_APP_NAME}</strong> একটি গ্রাহকবান্ধব ই-কমার্স
                প্ল্যাটফর্ম। আমাদের লক্ষ্য হলো স্বচ্ছ, ফেয়ার এবং সন্তোষজনক কেনাকাটার
                অভিজ্ঞতা প্রদান করা।
              </p>

              {/* Exchange Policy */}
              <section className="mb-5">
                <h4 className="fw-semibold mb-3">🔁 এক্সচেঞ্জ পলিসি</h4>
                <ol>
                  <li>ডেলিভারি এজেন্টের সামনে পণ্য চেক করে গ্রহণ করুন।</li>
                  <li>
                    আনবক্সিং ভিডিও বাধ্যতামূলক। ভিডিও ছাড়া মিসিং বা ড্যামেজের
                    অভিযোগ গ্রহণযোগ্য নয়।
                  </li>
                  <li>
                    ত্রুটিপূর্ণ বা ভুল পণ্য পেলে <strong>৭ দিনের মধ্যে</strong>{" "}
                    ক্লেইম করতে হবে। স্টক না থাকলে রিফান্ড দেওয়া হবে।
                    <br />
                    ফর্ম:
                    <NavLink to="../complain-box">Complain Box</NavLink>
                  </li>
                  <li>
                    সঠিক পণ্য পেয়েও পরিবর্তন চাইলে ৭ দিনের মধ্যে ফর্ম পূরণ করতে
                    হবে। শিপিং চার্জ <strong>2X</strong> প্রযোজ্য।
                  </li>
                  <li>
                    নির্ধারিত ফর্ম ছাড়া অন্য কোনো ক্লেইম গ্রহণযোগ্য নয়।
                  </li>
                </ol>
              </section>

              {/* Return Policy */}
              <section className="mb-5">
                <h4 className="fw-semibold mb-3">↩️ রিটার্ন ও রিফান্ড পলিসি</h4>
                <ol>
                  <li>
                    ত্রুটিপূর্ণ পণ্য ডেলিভারি এজেন্ট থাকা অবস্থায় রিটার্ন করা যাবে।
                  </li>
                  <li>
                    মাইন্ড চেঞ্জ বা অনুপস্থিতির কারণে রিটার্ন করলে ডেলিভারি চার্জ
                    প্রযোজ্য:
                    <ul className="mt-2">
                      <li>ঢাকার বাইরে: ১১০/-</li>
                    </ul>
                  </li>
                  <li>
                    ব্যবহৃত, ধৌত বা সিল্ড প্রডাক্ট আনবক্স করলে রিটার্ন বা এক্সচেঞ্জ
                    সম্ভব নয়।
                  </li>
                  <li>
                    মাইন্ড চেঞ্জ রিটার্নে <strong>2X কুরিয়ার চার্জ</strong> +{" "}
                    <strong>৫০/- প্যাকেজিং চার্জ</strong> প্রযোজ্য।
                  </li>
                  <li>
                    পণ্য ওয়্যারহাউজে পৌঁছানোর পর <strong>৭–১৫ কার্যদিবসের</strong>{" "}
                    মধ্যে রিফান্ড করা হবে।
                  </li>
                </ol>
              </section>

              {/* Important */}
              <section className="mb-4">
                <h5 className="fw-semibold">📌 গুরুত্বপূর্ণ নির্দেশনা</h5>
                <p>
                  নির্ধারিত ফর্ম পূরণ না করলে {process.env.REACT_APP_NAME} কোনো অভিযোগ সমাধানের
                  দায়ভার নেবে না।
                </p>
                <p>
                  <strong>হটলাইন:</strong> 01736433759 (১০ AM – ৭ PM)
                  <br />
                  <strong>Email:</strong> info@lungisari.com
                </p>
              </section>

              <p className="fw-medium">
                {process.env.REACT_APP_NAME}-এর পলিসির সাথে একমত না হলে অনুগ্রহ করে অর্ডার করা থেকে
                বিরত থাকুন।
              </p>

              <p className="mt-3">
                সমস্যা সমাধান টিম,
                <br />
                <strong>{process.env.REACT_APP_NAME} 🤝</strong>
              </p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ReturnExchange;
